<template>
  <modal ref='bulkMoveItemsModal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('bulk_items.move.bulk_move') }} </h5>
    </template>

    <template #body>
      <form @submit.prevent='bulkMoveItems()' class="modal-fix">
        <div class='modal-body'>
          <p>{{ $t('bulk_items.move.choose_folder') }}</p>
          <label>{{ $t('record_show.folder') }}</label>

          <div>
            <single-select :template='folderTemplate' :getter='getFolders' name='folder_id' v-model='folder' />
          </div>
        </div>

        <div class='modal-footer'>
          <div class="btn btn-outline-primary" @click.prevent="closeModal()"> {{ $t('bulk_items.move.cancel') }} </div>
          <input type='submit' :value="$t('folder_show.modals.move.submit')" class='btn btn-primary float-right' />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import _modal from './../../_modal'
import _single_select from '../_infinite_single_select'

export default {
  components: {
    'modal': _modal,
    'single-select': _single_select,
  },
  data: function () {
    return {
      folderIds: [],
      recordIds: [],
      folder: {},
      breadcrumbsLength: 0,
    }
  },
  methods: {
    open(folders, records) {
      this.folderIds = (folders || []).map(f => f.id)
      this.recordIds = (records || []).map(r => r.id)

      this.setBreadcrumbsLength(folders)

      this.$refs.bulkMoveItemsModal.open()
    },
    setBreadcrumbsLength(folders){
      let subfoldersLength = (folders || []).map(f => f.breadcrumbs.length)

      this.breadcrumbsLength = Math.min(...subfoldersLength)
    },
    closeModal() {
      this.folder = {}

      this.$refs.bulkMoveItemsModal.close()
    },
    bulkMoveItems(){
      let paramsRecords = {
        record_ids: this.recordIds,
        folder_id: this.folder.id
      }

      let paramsFolders = {
        folder_ids: this.folderIds,
        folder_id: this.folder.id
      }

      const promises = [
        this.store.bulkMoveRecords(paramsRecords),
        this.store.bulkMoveFolders(paramsFolders)
      ]

      Promise.allSettled(promises).then(() => {
        this.store.sendMetrics({name: 'bulk_move_items', params: this.$route.params, path: this.$route.fullPath})
        this.$emit('success')
        this.$toastr.success(this.$t('bulk_items.move.success'))
        this.closeModal()
      })
    },
    getFolders(params) {
      return this.listStore.getFolders(params)
    },
  }
}
</script>

<style lang="sass" scoped>

</style>

